module.exports = __webpack_public_path__ + "static/media/categories_step_2_2.187c14ae.svg";